import React from 'react'
import DeviceListView from '../../components/listView/DeviceListView';


const ListViewContainer = ({ }) => {



  return (
    <DeviceListView />

  );
};

export default ListViewContainer